import React, { Component, Fragment } from 'react';
import { cloneDeep } from 'lodash';
import { Col, Form, Input, Modal, Radio, Row, Select, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class SliderForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: []
        };

        this.formRef = React.createRef();
    }

    handleCategory = () => {
        this.formRef.current.setFieldsValue({ subCategory: undefined });
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            const formData = new FormData();

            formData.append('type', values.type);
            formData.append('location', values.location);
            formData.append('device', values.device);

            switch (values.type) {
                case 'category':
                    formData.append('value', values.subCategory ? values.subCategory : values.mainCategory);
                    break;
                case 'tag':
                    formData.append('value', values.tag);
                    break;
                case 'link':
                    formData.append('value', values.link);
                    break;
                default:
                    break;
            }

            if (values.image && values.image.fileList && values.image.fileList.length)
                formData.append('image', values.image.file, values.image.file.name);

            this.props.onSubmit(formData);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);

        switch (cloneData.type) {
            case 'category':
                const category = this.props.categories.find(o => o.id === parseInt(cloneData.value));

                if (category) {
                    if (category.subCategory)
                        cloneData.subCategory = cloneData.value;
                    else
                        cloneData.mainCategory = cloneData.value;
                }
                break;
            case 'tag':
                cloneData.tag = parseInt(cloneData.value);
                break;
            case 'link':
                cloneData.link = cloneData.value;
                break;
            default:
                break;
        }

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { categories, onCancel, submitting, tags, visible } = this.props;
        const { fileList, editMode } = this.state;

        const props = {
            onRemove: file => {
                this.setState({ fileList: [] });
            },
            beforeUpload: file => {
                this.setState({ fileList: [file] });
                return false;
            },
            showUploadList: {
                showRemoveIcon: editMode
            },
            fileList
        };

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} md={12}>
                            <Form.Item name="type" label={Resources.type} rules={Rules.required}>
                                <Radio.Group>
                                    <Radio value="category">{Resources.category}</Radio>
                                    <Radio value="tag">{Resources.tag}</Radio>
                                    <Radio value="link">{Resources.link}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item name="location" label={Resources.location} rules={Rules.required}>
                                <Radio.Group>
                                    <Radio value="top">{Resources.top}</Radio>
                                    <Radio value="center">{Resources.center}</Radio>
                                    <Radio value="bottom">{Resources.bottom}</Radio>
                                    <Radio value="profile">{Resources.profile}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item name="device" label={Resources.device} rules={Rules.required}>
                                <Radio.Group>
                                    <Radio value="web">{Resources.web}</Radio>
                                    <Radio value="mobile">{Resources.app}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.type !== currentValues.type} noStyle>
                            {({ getFieldValue }) => {
                                switch (getFieldValue('type')) {
                                    case 'category':
                                        return (<Fragment>
                                            <Col xs={24} md={12}>
                                                <Form.Item name="mainCategory" label={`${Resources.category} ${Resources.main}`} rules={Rules.required}>
                                                    <Select filterOption placeholder={Resources.choose} onSelect={this.handleCategory} optionFilterProp="name" showSearch>
                                                        {categories.filter(o => !o.subCategory).map(o => <Select.Option key={o.id} value={o.id} name={o.name}>{o.name}</Select.Option>)}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.mainCategory !== currentValues.mainCategory} noStyle>
                                                    {({ getFieldValue }) => <Form.Item name="subCategory" label={`${Resources.category} ${Resources.sub}`}>
                                                        <Select filterOption placeholder={Resources.choose} optionFilterProp="name" showSearch>
                                                            {categories.filter(o => o.subCategory === getFieldValue('mainCategory')).map(o => <Select.Option key={o.id} value={o.id} name={o.name}>{o.name}</Select.Option>)}
                                                        </Select>
                                                    </Form.Item>}
                                                </Form.Item>
                                            </Col>
                                        </Fragment>)
                                    case 'tag':
                                        return (<Col xs={24}>
                                            <Form.Item name="tag" label={Resources.tags} rules={Rules.required}>
                                                <Select filterOption placeholder={Resources.choose} optionFilterProp="name" showSearch>
                                                    {tags.map(o => <Select.Option key={o.id} value={o.id} name={o.name}>{o.name}</Select.Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>)
                                    case 'link':
                                        return (<Col xs={24}>
                                            <Form.Item name="link" label={Resources.link} rules={Rules.required}>
                                                <Input type="text" className="ant-input-ltr" />
                                            </Form.Item>
                                        </Col>)
                                    default:
                                        return null;
                                }
                            }}
                        </Form.Item>
                        <Col xs={24}>
                            <Form.Item name="image" label={Resources.image} rules={editMode ? [] : Rules.required}>
                                <Upload.Dragger {...props}>
                                    <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                    <p className="ant-upload-hint">{Resources.uploadText}</p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default SliderForm;